import React from "react";
import Chart from "react-apexcharts";

const DashboardDataAnalysisChart = () => {
  const chartState = {
    options: {
      chart: {
        id: "basic-line",
      },
      xaxis: {
        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
      },
    },
    series: [
      {
        name: "series-1",
        data: [30, 40, 45, 50, 49, 60, 70, 91],
      },
      {
        name: "series-2",
        data: [15, 50, 90, 110, 200, 180, 140, 197],
      },
    ],
  };
  return (
    <Chart
      options={chartState.options}
      series={chartState.series}
      type="line"
      width="100%"
      height="300"
    />
  );
};

export default DashboardDataAnalysisChart;
